'use client'

import React, { useEffect, useState } from 'react'

import Svg from 'Atoms/Svg'

const checkShowTimeMs = 2000

const ClickToCopy = ({ textToCopy, size = 1.25, className }) => {
  const [showCheck, setShowCheck] = useState(false)

  useEffect(() => {
    let timer
    if (showCheck) {
      timer = setTimeout(() => {
        setShowCheck(false)
      }, checkShowTimeMs)
    }
    return () => clearTimeout(timer)
  }, [showCheck])

  function handleCopy() {
    navigator.clipboard.writeText(textToCopy)
    setShowCheck(true)
  }

  return showCheck ? (
    <Svg icon="check" tone="subtle" size={size} className={className} />
  ) : (
    <Svg icon="copy" tone="subtle" size={size} className={className} onClick={handleCopy} />
  )
}

export default ClickToCopy
